import type { Content as ContentType } from 'types/capi/content';

import { ContentBlockCore } from '~/modules/ste/ContentBlock';
import type { ColumnPosition } from '~/modules/ste/ModuleRow';
import { useModuleRowContext } from '~/modules/ste/ModuleRow';

type Props = {
  collapseBottom?: boolean;
  collapseTop?: boolean;
  columnPosition: ColumnPosition;
  content?: ContentType[];
  title?: string;
};

export default function EmbeddedContentBlock({
  collapseBottom,
  collapseTop,
  content,
  columnPosition,
  title
}: Props) {
  const moduleRow = useModuleRowContext();

  const items = content ?? [];
  if (!title && items.length === 0) return null;

  const xPadding =
    columnPosition === 'first'
      ? 'md:pl-4 lg:pl-0'
      : columnPosition === 'last'
        ? 'md:pr-4 lg:pr-0'
        : '';
  const yPadding =
    collapseTop && collapseBottom
      ? ''
      : collapseTop
        ? 'md:pb-8'
        : collapseBottom
          ? 'md:pt-8'
          : 'md:py-8';

  return (
    <div
      className={`flex w-full flex-col gap-6 ${xPadding} ${yPadding} ${
        !moduleRow?.narrow ? 'md:mx-auto md:max-w-[360px]' : ''
      }`}
    >
      <ContentBlockCore content={content} title={title} />
    </div>
  );
}
